import { render, staticRenderFns } from "./ScreenObsequiosFacturador.vue?vue&type=template&id=758b5400"
import script from "./ScreenObsequiosFacturador.vue?vue&type=script&lang=js"
export * from "./ScreenObsequiosFacturador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports